import { render, staticRenderFns } from "./MacroProductsManagement.vue?vue&type=template&id=24b42ec4&scoped=true&"
import script from "./MacroProductsManagement.vue?vue&type=script&lang=ts&"
export * from "./MacroProductsManagement.vue?vue&type=script&lang=ts&"
import style0 from "./MacroProductsManagement.vue?vue&type=style&index=0&id=24b42ec4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b42ec4",
  null
  
)

export default component.exports